import RpcService  from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';

import type Offer from '@/domains/Offers/Offer';
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import type RpcDataSort from "@/core/services/Rpc/RpcDataSort";
import type ProductCategory from "@/domains/ProductCategories/ProductCategory";

class OffersDAO {

	/**
	 * Получить список оферов
	 */
	static async getList(
		filters?: {
			onlyMine?:             boolean;
			productCategory?:      ProductCategory;
			isBookmarked?:         boolean;
			isPublished?:          boolean;
			isAcceptingPreorder?:  boolean;
			isSamples?:            boolean;
			requireNestedObjects?: boolean;
			pattern?:              string;
      sellerId?:             number;
      isOutdated?:           boolean;
      buyerId?:              number; // на бэке нет этого фильтра
		},
		pagination?: RpcDataPagination,
		sort?:       RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
			'offers.getList',
      {
        ...filters,
        productCategory: filters?.productCategory ? { id: filters.productCategory.id } : undefined,
      },
			pagination,
			sort,
			true, null, null, false,
			{ abortPrevious: true },
		);
	}
	/**
	 * Получить конкретный офер
	 */
	static async get(id: number, version: number | null = null): Promise<RpcResponse> {
		const payload: { id: number, version?: number } = { id };
		if (version !== null) {
			payload.version = version;
		}

		return await RpcService.makeRequest('offers.get', payload);
	}

	/**
	 * Создать офер
	 */
	static async add(offer: Offer): Promise<RpcResponse> {
		return await RpcService.makeRequest('offers.add', { offer });
	}

	/**
	 * Обновить офер
	 */
	static async update(offer: Offer): Promise<RpcResponse> {
		return await RpcService.makeRequest('offers.update', { offer });
	}

	/**
	 * Удалить офер
	 */
	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('offers.delete', { id });
	}

	/**
	 * Снять с публикации
	 */
	static async unpublish(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('offers.unpublish', { id });
	}
}

export default OffersDAO;
